import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-134">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center" data-id="element-135">
        <FadeIn data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-teal mb-8" data-id="element-137">
            A los 40+, la vergüenza financiera pesa más.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-138">
          <div className="space-y-6 text-lg text-brand-charcoal/80 leading-relaxed text-left md:text-center" data-id="element-139">
            <p data-id="element-140">
              Deberías "tenerlo todo bajo control", pero la realidad es que tu
              bandeja de entrada está llena de recibos que no te atreves a
              abrir.
            </p>
            <p data-id="element-141">
              Vives con el miedo constante de que un olvido insignificante se
              convierta en una crisis financiera. Has pagado cientos (o miles)
              de dólares en intereses y multas simplemente porque tu memoria de
              trabajo se saturó.
            </p>
            <p data-id="element-142">
              La parálisis por análisis te impide actuar, y el ciclo de culpa
              solo te hace gastar más para buscar un alivio momentáneo de
              dopamina.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}